<template>
  <div id="companyChild" class="dashboard-editor-container">
    <!-- 设备基本信息 -->
    <el-row>
      <div class="headTitle">
        <!-- <span style="font-size: 18px;">
          上级公司ID：{{ basicinfo.companyId }}
        </span>
        <span class="fontStyle2" /> -->
        <span style="font-size: 18px;">
          {{ $t('company.Parentcompany') }}：{{ basicinfo.companyName }}
        </span>
      </div>
    </el-row>
    <el-row id="tableWarp">
      <el-col :xs="24" :sm="24" :lg="24" class="card-panel-col">
        <!-- 列表 -->
        <div style="position: relative;padding:10px 20px 20px;">
          <div id="filter" style="margin-top:20px;">
            <div style="display: fixed;">
              <!-- <span style="line-height: 36px;">{{ $t('dashboard.DeviceName') }}</span> -->
              <el-input v-model="tableObj.companyName" :placeholder="$t('company.Companyname')" clearable class="input-with-select deviceNameTable" @keyup.enter.native="changeSearch(tableObj.companyName)">
                <el-button slot="append" icon="el-icon-search" @click="changeSearch(tableObj.companyName)" />
              </el-input>
              <el-button type="primary" icon="el-icon-plus" style="float: right;margin-bottom: 10px;" @click="add" />
            </div>
          </div>
          <el-table :data="tableData" border style="padding-left: 5px;width:100%;">
            <el-table-column prop="companyName" :label="$t('company.Companyname')" min-width="20%" />
            <el-table-column prop="id" :label="$t('company.CompanyID')" min-width="10%" />
            <el-table-column prop="companyUrl" :label="$t('company.Companywebsite')" min-width="20%" />
            <el-table-column prop="companyAddr" :label="$t('company.Companyaddress')" min-width="20%" />
            <el-table-column prop="companyCount" :label="$t('company.Numberofbranches')" min-width="10%">
              <template slot-scope="scope">
                <el-link type="primary" @click="goToChildPage(scope.row)">
                  {{ scope.row. companyCount }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="userCount" :label="$t('company.Numberofaccounts')" min-width="10%">
              <template slot-scope="scope">
                <el-link type="primary" @click="goToUserCountPage(scope.row)">
                  {{ scope.row. userCount }}
                </el-link>
              </template>
            </el-table-column>
            <el-table-column prop="action" :label="$t('yhubReport.Operating')" min-width="10%" align="center">
              <template slot-scope="scope">
                <div style="text-align: center;">
                  <el-button type="primary" icon="el-icon-edit" size="mini" @click="edit(scope.row)" />
                  <!-- <el-button v-if="scope.row.children" type="primary" icon="el-icon-plus" size="mini" @click="add" /> -->
                  <el-button type="primary" icon="el-icon-delete " size="mini" @click="deleteOne(scope.row)" />
                </div>
              </template>
            </el-table-column>
          </el-table>

          <!-- 列表模块————分页 -->
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination
                v-if="pageshow"
                background
                current-page.sync="listQuery.pageInfo.page"
                :page-sizes="listQuery.pageInfo.pageList"
                :page-size="listQuery.pageInfo.limit"
                layout="total, sizes, prev, pager, next, jumper"
                :total="listQuery.pageInfo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
              />
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
    <!-- 新增/编辑--弹窗 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="isShowPop">
      <el-form ref="dataForm" :rules="addCompanyRules" :model="companyForm" label-position="right" label-width="180px" style="width: 80%;max-width: 600px;margin-left: 50px;">
        <el-form-item v-if="companyForm.companyParentName!=''" :label="$t('company.Parentcompany')">
          <el-input v-model="companyForm.companyParentName" :disabled="true" />
        </el-form-item>
        <el-form-item :label="$t('company.Companyname')" prop="companyName">
          <el-input v-model="companyForm.companyName" />
        </el-form-item>
        <el-form-item :label="$t('company.Companyaddress')">
          <el-input v-model="companyForm.companyAddr" />
        </el-form-item>
        <el-form-item :label="$t('company.Companywebsite')">
          <el-input v-model="companyForm.companyUrl" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer" style="display: flex;justify-content: flex-end;">
        <el-button @click="isShowPop=false">{{ $t('button.Cancel') }}</el-button>
        <el-button class="filter-item" type="primary" @click="confirmPop('dataForm')">{{ $t('button.Confirm') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { companyPageList, insert, update, deleteById } from '@/api/company'
import { listRentalDevice, addRentalDevice, findSnList, listByCompanyParentId, getList, updateGnssGeofenceStatus } from '@/api/leaseManagement'
import { pagination } from '@/utils/init_table' // 分页
import { getDateAndHour } from '@/utils/updateTime.js'
import i18n from '@/i18n'
import PieChartCici from '@/components/pieChart'
import lineChartTwo from '@/components/lineChartTwo'
var Base64 = require('js-base64').Base64

export default {
  name: 'DashboardAdmin',
  components: {},
  data() {
    return {
      // 分页----start
      listQuery: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow: true,
      // 分页----end
      tableData: [],
      addCompanyRules: {
        companyName: [{ required: true, message: i18n.t('lease.Cannotbeblanked'), trigger: 'blur' }]
      },
      companyForm: {},
      isAdd: false,
      tableObj: {
        companyName: '' // 删选--companyName
      },
      isShowPop: false,
      basicinfo: {
        companyId: Base64.decode(this.$route.query.id).split('+')[0],
        companyName: this.$route.query.companyName
      }
    }
  },
  computed: {
    language() {
      return this.$store.state.language
    }
  },
  watch: {
    // allChildCompanyArr: {
    //   handler(newValue, oldValue) {
    //     this.allChildCompanyArr = newValue // 把新值赋值给我们的属性数据
    //     this.queryList()
    //   },
    //   deep: true
    // },
  },
  mounted() {
    this.queryList()
  },
  created() {},
  methods: {
    queryList() {
      var param = {
        'companyAddr': '',
        'companyEmail': '',
        'companyName': this.tableObj.companyName || '',
        'companyUrl': '',
        'pageNum': this.listQuery.pageInfo.pageNum,
        'pageSize': this.listQuery.pageInfo.pageSize,
        'parentId': Base64.decode(this.$route.query.id).split('+')[0]
      }
      this.basicinfo.companyName = this.$route.query.companyName

      companyPageList(param).then(res => {
        if (res.resultCode == 1001) {
          this.tableData = res.resultModel.list // 列表数据
          this.listQuery.pageInfo.total = res.resultModel.total // 分页
          this.tableData.forEach((v, i) => {
            if (v.companyParentName) this.companyForm.companyParentName = v.companyParentName
          })
        }
      })
    },
    edit(row) { // 弹窗--编辑
      if (row) {
        this.companyForm = JSON.parse(JSON.stringify(row))
      }
      this.isAdd = false
      this.isShowPop = true
    },
    add() { // 弹窗--新增
      this.isShowPop = true
      this.companyForm = {}
      this.companyForm.companyParentName = this.$route.query.companyName
      this.companyForm.companyParentId = Base64.decode(this.$route.query.id).split('+')[0]
      this.isAdd = true
    },
    confirmPop(formName) { // 弹窗--提交
      var param = {
        'appStyleId': '',
        'companyAddr': this.companyForm.companyAddr,
        'companyCount': '',
        'companyEmail': '',
        'companyLevel': '2',
        'companyName': this.companyForm.companyName,
        'companyParentId': this.companyForm.companyParentId,
        'companyParentName': this.companyForm.companyParentName,
        'companyTel': '',
        'companyUrl': this.companyForm.companyUrl,
        'hasNext': true,
        'userCount': 0
      }
      var param1 = {
        'companyAddr': this.companyForm.companyAddr,
        'companyEmail': '',
        'companyName': this.companyForm.companyName,
        'companyTel': '',
        'companyUrl': this.companyForm.companyUrl,
        'id': this.companyForm.id
      }
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAdd) { // 新增
            insert(param).then(res => {
              if (res.resultCode == 1001) {
                this.isShowPop = false
                this.isAdd = false
                this.queryList()
                this.$message({
                  type: 'success',
                  message: i18n.t('warningSet.submitted')
                })
              }
            })
          } else {
            update(param1).then(res => {
              if (res.resultCode == 1001) {
                this.isShowPop = false
                this.queryList()
                this.$message({
                  type: 'success',
                  message: i18n.t('warningSet.submitted')
                })
              }
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    deleteOne(row) { // 删除
      this.$confirm(i18n.t('company.Deletecompanyinfo'), '', {// 是否删除该公司信息？
        confirmButtonText: i18n.t('button.Confirm'), // '确定'
        cancelButtonText: i18n.t('button.Cancel'),
        type: 'warning'
      }).then(() => {
        deleteById({ 'id': row.id }).then(res => {
          if (res.resultCode == '1001') {
            this.queryList()
            this.$message({
              type: 'success',
              message: 'Succeed!'
            })
          }
        })
      }).catch(() => {})
    },
    goToChildPage(row) { // 去子公司页
      var routeData = this.$router.resolve({
        path: '/setting/childCompany',
        query: {
          id: Base64.encode(row.id),
          companyName: row.companyName
          // companyParentId: row.companyParentId
          // companyAddr: row.companyAddr,
          // companyUrl: row.companyUrl
        }
      })
      window.open(routeData.href, '_self')
      this.listQuery.pageInfo.pageNum = 1
      this.tableObj.companyName = ''
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    goToUserCountPage(row) { // 去公司账号页
      var routeData = this.$router.resolve({
        path: '/setting/companyUser',
        query: {
          id: Base64.encode(row.id),
          companyName: row.companyName,
          companyParentId: row.companyParentId,
          companyAddr: row.companyAddr,
          companyUrl: row.companyUrl
        }
      })
      window.open(routeData.href, '_self')
    },
    change(e) {
      this.$forceUpdate()
    },
    // 筛选改变事件
    changeSearch(inputDevName) {
      // 去掉首尾空格
      if (this.tableObj.companyName) this.tableObj.companyName = this.tableObj.companyName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      this.listQuery.pageInfo.pageNum = 1
      this.pageshow = false
      this.queryList()
      this.$nextTick(() => {
        this.pageshow = true
      })
    },
    // 分页----start
    handleSizeChange(val, e) { // 每一页的列表的行数 10 20 50
      this.listQuery.pageInfo.pageSize = val
      this.queryList()
    },
    handleCurrentChange(val, e) { // 选中某一页
      this.listQuery.pageInfo.pageNum = val
      this.queryList()
    }
    // 分页----end
  }
}
</script>

<style lang="scss" scoped>
p{
  margin:0
}
#companyChild{
  height:100%;
  // background: #fff;
  #tableWarp{
    background:#fff;
    margin-top:32px;
  }
}
</style>
<style lang="scss">
#companyChild{
  .el-table th.gutter{
    display: table-cell!important;
  }
  #companyPopId{
    .el-autocomplete,.el-cascader--medium,.el-input,.deviceSnPop .el-select{
      width:80%!important;
    }
    // .deviceSnPop .el-input{
    //   width:100%!important;
    // }
    .el-select.filter-item.el-select--medium{
      width:100%!important;
    }
  }
  #filter{
    .el-input-group {
      width: 40%;
      max-width:400px;
    }
  }

}
</style>
